<template>
  <div class="container-nzidoo ">
    <page-title title="auth.account" />
    <div class="row mx-0">
      <!-- Header -->
      <div class="header row d-none">
        <div class="col-12">
          <button class="btn-back" @click="$router.go(-1)">
            <i class="icon-arrow-left"></i>
          </button>
        </div>
      </div>

      <!-- Profile + Sections -->
      <!-- Left column -->
      <div class="col-md-6 mb-4">
        <div class="user-profile-section">
          <div class="user-avatar">
            <img :src="user.picture === null ? userpng : config.storageUrl + user.picture" alt="user image" />
          </div>
          <div class="user-info">
            <h2>{{ user.firstname }} {{ user.lastname }}</h2>
            <p>{{ user.email }}</p>
          </div>
        </div>

        <!-- Mon compte -->
        <div class="section">
          <h3 class="section-title">{{ $t('profile.account.title') }}</h3>

          <div class="menu-item" @click="navigateToIdentity">
            <div class="menu-item-left">
              <i class="icon-user"></i>
              <span>{{ $t('profile.account.identity') }}</span>
            </div>
            <div class="menu-item-right">
              <span class="admin-badge" v-if="user.roles && user.roles[0] === 'ROLE_ADMIN'">
                {{ $t('profile.roles.admin') }}
              </span>
              <span class="verified-badge" v-else-if="user.validated_client">
                {{ $t('profile.status.verified') }}
              </span>
              <span class="unverified-badge" v-else>
                {{ $t('profile.status.unverified') }}
              </span>
              <i class="icon-chevron-right"></i>
            </div>
          </div>

          <div class="menu-item" @click="navigateToCoordinates">
            <div class="menu-item-left">
              <i class="icon-home"></i>
              <span>{{ $t('profile.account.address') }}</span>
            </div>
            <i class="icon-chevron-right"></i>
          </div>

          <div class="menu-item" @click="navigateToBankCard">
            <div class="menu-item-left">
              <i class="icon-card"></i>
              <span>{{ $t('profile.account.bankCard') }}</span>
            </div>
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </div>

      <!-- Right column -->
      <div class="col-md-6 mb-4">

        <!-- Assistance -->
        <div class="section">
          <h3 class="section-title">{{ $t('profile.support.title') }}</h3>

          <div class="menu-item" @click="navigateToFAQ">
            <div class="menu-item-left">
              <i class="icon-help"></i>
              <span>{{ $t('profile.support.faq') }}</span>
            </div>
            <i class="icon-chevron-right"></i>
          </div>

          <div class="menu-item" @click="navigateToContact">
            <div class="menu-item-left">
              <i class="icon-message"></i>
              <span>{{ $t('profile.support.contact') }}</span>
            </div>
            <i class="icon-chevron-right"></i>
          </div>
        </div>
        <!-- Mes paramètres -->
        <div class="section">
          <h3 class="section-title">{{ $t('profile.settings.title') }}</h3>

          <div class="menu-item" @click="navigateToNotifications">
            <div class="menu-item-left">
              <i class="icon-bell"></i>
              <span>{{ $t('profile.settings.notifications') }}</span>
            </div>
            <i class="icon-chevron-right"></i>
          </div>

          <div v-if="false" class="menu-item" @click="navigateToNewsletters">
            <div class="menu-item-left">
              <i class="icon-mail"></i>
              <span>{{ $t('profile.settings.newsletters') }}</span>
            </div>
            <i class="icon-chevron-right"></i>
          </div>

          <div class="menu-item" @click="navigateToLanguage">
            <div class="menu-item-left">
              <i class="icon-globe"></i>
              <span>{{ $t('profile.settings.language') }}</span>
            </div>
            <div class="menu-item-right">
              <span class="language-text">{{ $t('profile.settings.languageName') }}</span>
              <i class="icon-chevron-right"></i>
            </div>
          </div>

          <div class="menu-item" @click="navigateToDataManagement">
            <div class="menu-item-left">
              <i class="icon-shield"></i>
              <span>{{ $t('profile.settings.dataManagement') }}</span>
            </div>
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </div>



      <!-- Loader & Notifications -->
      <loading-spinner v-if="loader" />
      <notifications style="top:5%;" width="35%" group="success" position="top center" />
      <notifications style="top:5%;" width="35%" group="error" position="top center" />
      <v-dialog />
    </div>
  </div>
</template>

<script>
import config from "@/config";
import LoadingSpinner from '@/components/templates/LoadingSpinner.vue';
import userpng from '@/assets/img/user/user.webp';
import PageTitle from '@/components/templates/PageTitle.vue';

export default {
  components: {
    LoadingSpinner,
    PageTitle,
  },
  data() {
    return {
      userpng: userpng,
      loader: false,
      config: config,
    };
  },
  methods: {
    navigateToIdentity() {
      // this.$router.push({ name: 'manageAccount', params: { activeTab: 'client' } });
      this.$router.push({ name: 'AccountInformations' });
    },
    navigateToCoordinates() {
      // this.$router.push({ name: 'manageAccount', params: { activeTab: 'profile' } });
      this.$router.push({ name: 'AccountCredentials' });
    },
    navigateToBankCard() {
      // this.$router.push('/bank-card');
      alert('a faire');
    },
    navigateToCustomize() {
      // this.$router.push('/customize');
      alert('a faire');
    },
    navigateToNotifications() {
      // this.$router.push('/notifications');

      alert('a faire');
    },
    navigateToNewsletters() {
      // this.$router.push('/newsletters');

      alert('a faire');
    },
    navigateToLanguage() {
      // this.$router.push('languageSwitcher');
      this.$router.push({ name: 'languageSwitcher' });
    },
    navigateToDataManagement() {
      // this.$router.push('/data-management');
      alert('a faire');
    },
    navigateToFAQ() {
      this.$router.push('/faq');
    },
    navigateToContact() {
      this.$router.push('/contact');
    },
    showPopUpConfirmation(userId) {
      var self=this;
      this.$modal.show("dialog", {
        title: "Confirmation",
        text: "<label class='color-red'>Attention ! </label> En supprimant votre compte sur Nzidoo, toutes vos annonces passées et à venir seront supprimées ainsi que votre profil. Un compte supprimé est définitivement perdu",
        buttons: [
          {
            title: "Annuler",
            handler: () => {
              self.$modal.hide("dialog");
              return false;
            },
          },
          {
            title: "Confirmer",
            handler: () => {
              self.deleteAccount(userId);
              self.$modal.hide("dialog");
            },
          },
        ],
      });
    },
    deleteAccount(userId) {
      var self=this;
      self.loader=true;

      this.$axios({
        url: "user/remove/"+userId,
        method: "POST",
      })
        .then(() => {
          self.$notify({
            group: "success",
            title: "Bravo !",
            type: "success",
            text: "Utilisateur supprimé avec succès!",
          });
          self.loader=false;
          self.logout();
        })
        .catch((err) => {
          console.log(err);

          self.loader=false;
          self.$notify({
            group: "error",
            title: "Erreur !",
            type: "error",
            text: "Une erreur est survenue !",
          });
        });
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
  },
};
</script>

<style scoped>
.header {
  background-color: white;
  padding: 15px 20px;
  display: flex;
  align-items: center;
}

.btn-back {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: var(--color-3);
}

.user-profile-section {
  background-color: white;
  padding: 30px 20px;
  text-align: center;
  margin-bottom: 20px;
}


.user-info h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 5px 0;
  color: var(--color-3);
}

.user-info p {
  font-size: 14px;
  color: var(--color-6);
  margin: 0;
}

.section {
  background-color: white;
  margin-bottom: 20px;
  padding: 0 20px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-6);
  padding: 15px 0 10px 0;
  margin: 0;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:active {
  background-color: #f9f9f9;
}

.menu-item-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.menu-item-left i {
  font-size: 20px;
  color: var(--color-3);
  width: 24px;
  text-align: center;
}

.menu-item-left span {
  font-size: 16px;
  color: var(--color-3);
}

.menu-item-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-badge {
  background-color: #d4e1f4;
  color: #2284c5;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.verified-badge {
  background-color: #d4f4dd;
  color: #22c55e;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.unverified-badge {
  background-color: #f4d4d4;
  color: #c52222;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.language-text {
  color: var(--color-6);
  font-size: 15px;
}

.icon-chevron-right {
  font-size: 18px;
  color: var(--color-9);
}

.delete-section {
  padding: 20px;
  text-align: center;
}

.btn-delete {
  background-color: white;
  color: var(--color-oo);
  border: 1px solid var(--color-oo);
  padding: 12px 30px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-delete:hover {
  background-color: var(--color-oo);
  color: white;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader::after {
  content: '';
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Icon placeholders - replace with your icon library */
.icon-arrow-left::before {
  content: '←';
}

.icon-user::before {
  content: '👤';
}

.icon-home::before {
  content: '🏠';
}

.icon-card::before {
  content: '💳';
}

.icon-palette::before {
  content: '🎨';
}

.icon-bell::before {
  content: '🔔';
}

.icon-mail::before {
  content: '✉️';
}

.icon-globe::before {
  content: '🌐';
}

.icon-shield::before {
  content: '🛡️';
}

.icon-help::before {
  content: '❓';
}

.icon-message::before {
  content: '💬';
}
</style>